var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 426,
    viewBox: "0 0 485 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0803 -4.57764e-05L489.242 216.664L482.165 316.182L7.63525 93.1299L14.0803 -4.57764e-05Z",
    fill: "url(#paint0_linear_239_475)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0959 22.6124L489.258 239.277L482.181 316.31L7.65088 93.2583L14.0959 22.6124Z",
    fill: "url(#paint1_linear_239_475)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.081 242.158L186.276 259.654L186.453 177.565L138.081 154.558V242.158Z",
    fill: "url(#paint2_linear_239_475)",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.453 264.293L111.135 309.668V141.676L186.453 177.574V264.293Z",
    fill: "url(#paint3_linear_239_475)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.134,
    cy: 325.356,
    rx: 206.134,
    ry: 100.644,
    fill: "url(#paint4_radial_239_475)",
    fillOpacity: 0.6
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.084 242.164L111.135 309.668V141.676L138.084 154.553V242.164Z",
    fill: "url(#paint5_linear_239_475)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.796 102.728L185.82 48.5459L283.037 48.7694L216.213 106.405L175.796 102.728Z",
    fill: "url(#paint6_linear_239_475)",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.212 106.403L175.794 102.728L138.081 154.551V242.16L180.761 241.32L215.866 191.179L216.212 106.403Z",
    fill: "url(#paint7_linear_239_475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.212 106.403L175.794 102.728L138.081 154.551V242.16L180.761 241.32L215.866 191.179L216.212 106.403Z",
    fill: "url(#paint8_radial_239_475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.212 106.403L175.794 102.728L138.081 154.551V242.16L180.761 241.32L215.866 191.179L216.212 106.403Z",
    fill: "url(#paint9_linear_239_475)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.794 102.728L223.986 120.225L186.457 177.573L138.088 154.554L175.794 102.728Z",
    fill: "url(#paint10_linear_239_475)",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.771 191.218L264.339 213.71L226.629 261.843L180.762 241.316L215.771 191.218Z",
    fill: "url(#paint11_linear_239_475)",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.794 102.729L223.986 120.226L264.405 123.903L216.21 106.405L175.794 102.729Z",
    fill: "url(#paint12_linear_239_475)",
    fillOpacity: 0.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.069 242.152L186.461 264.308L226.683 261.872L180.766 241.321L138.069 242.152Z",
    fill: "url(#paint13_linear_239_475)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M224.112 120.469L185.821 48.5459L111.135 141.676L186.461 177.566L224.112 120.469Z",
    fill: "url(#paint14_linear_239_475)",
    fillOpacity: 0.9
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M264.314 213.727L282.844 222.478V48.4181L264.362 123.919L264.314 213.727Z",
    fill: "url(#paint15_linear_239_475)",
    fillOpacity: 0.9
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.453 264.3L111.135 309.667L208.695 323.975L226.608 261.841L186.453 264.3Z",
    fill: "url(#paint16_linear_239_475)",
    fillOpacity: 0.9
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M264.329 213.71L282.835 222.477L208.694 323.975L226.607 261.84L264.329 213.71Z",
    fill: "url(#paint17_linear_239_475)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.112 120.469L185.821 48.5459H282.875L264.361 123.918L224.112 120.469Z",
    fill: "url(#paint18_linear_239_475)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M224.112 120.469L185.821 48.5459H282.875L264.361 123.918L224.112 120.469Z",
    fill: "url(#paint19_linear_239_475)",
    fillOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.261 309.796L138.115 242.088L186.454 264.301L111.261 309.796Z",
    fill: "url(#paint20_linear_239_475)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8385 186.053L490 402.717L482.165 316.294L7.63525 93.2421L14.8385 186.053Z",
    fill: "url(#paint21_linear_239_475)",
    fillOpacity: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8385 165.677L490 382.341L482.165 316.294L7.63525 93.2421L14.8385 165.677Z",
    fill: "url(#paint22_linear_239_475)",
    fillOpacity: 0.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.406 123.901L224.081 120.227L186.453 177.56V264.3L226.69 261.841L264.331 213.682L264.406 123.901Z",
    fill: "url(#paint23_linear_239_475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.406 123.901L224.081 120.227L186.453 177.56V264.3L226.69 261.841L264.331 213.682L264.406 123.901Z",
    fill: "url(#paint24_radial_239_475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.406 123.901L224.081 120.227L186.453 177.56V264.3L226.69 261.841L264.331 213.682L264.406 123.901Z",
    fill: "url(#paint25_linear_239_475)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_475",
    x1: 76.9447,
    y1: 63.7364,
    x2: 437.82,
    y2: 272.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9492ED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#7674EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#817FDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_475",
    x1: 76.9603,
    y1: 63.8647,
    x2: 437.836,
    y2: 273.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232183",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#232183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232183",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_239_475",
    x1: 138.081,
    y1: 173.723,
    x2: 187.684,
    y2: 177.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E39DE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_239_475",
    x1: 102.598,
    y1: 212.382,
    x2: 211.743,
    y2: 236.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0340296,
    stopColor: "#2B79ED",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#FCA6EF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_239_475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.134 325.356) rotate(90) scale(100.644 206.134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#A873FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_239_475",
    x1: 138.084,
    y1: 150.038,
    x2: 125.264,
    y2: 281.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2295D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2249D6",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_239_475",
    x1: 179.101,
    y1: 61.7426,
    x2: 216.758,
    y2: 113.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B86FA",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534769,
    stopColor: "#FCA6EF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716558,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_239_475",
    x1: 218.739,
    y1: 124.016,
    x2: 83.1419,
    y2: 215.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_239_475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.41 278.148) rotate(-90) scale(107.582 61.2294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_239_475",
    x1: 138.081,
    y1: 226.418,
    x2: 178.919,
    y2: 178.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_239_475",
    x1: 161.243,
    y1: 121.191,
    x2: 202.119,
    y2: 147.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4078CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E39DE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_239_475",
    x1: 261.265,
    y1: 217.175,
    x2: 178.25,
    y2: 244.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4078CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_239_475",
    x1: 207.833,
    y1: 105.492,
    x2: 206.875,
    y2: 120.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4078CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E39DE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_239_475",
    x1: 170.11,
    y1: 243.462,
    x2: 169.153,
    y2: 258.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4078CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E39DE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_239_475",
    x1: 137.129,
    y1: 105.784,
    x2: 192.892,
    y2: 162.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "#4B86FA",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#FCA6EF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_239_475",
    x1: 286.54,
    y1: 48.4181,
    x2: 329.476,
    y2: 67.3499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00889157,
    stopColor: "#1D2A9B",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645598,
    stopColor: "#FCA6EF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_239_475",
    x1: 111.135,
    y1: 301.534,
    x2: 235.28,
    y2: 282.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0340296,
    stopColor: "#4B5CFA",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#FCA6EF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_239_475",
    x1: 268.342,
    y1: 251.924,
    x2: 241.568,
    y2: 237.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0340296,
    stopColor: "#4B5CFA",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539474,
    stopColor: "#FCA6EF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_239_475",
    x1: 279.989,
    y1: 73.9476,
    x2: 239.013,
    y2: 132.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#29B2ED",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967948,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_239_475",
    x1: 263.287,
    y1: 127.751,
    x2: 230.914,
    y2: 70.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF439D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_239_475",
    x1: 132.87,
    y1: 238.639,
    x2: 186.888,
    y2: 275.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93E1",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_239_475",
    x1: 76.9447,
    y1: 63.8486,
    x2: 437.82,
    y2: 273.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232183",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#232183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232183",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_239_475",
    x1: 76.9447,
    y1: 63.8486,
    x2: 437.82,
    y2: 273.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232183",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#8A88EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232183",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_239_475",
    x1: 266.927,
    y1: 141.51,
    x2: 131.464,
    y2: 232.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_239_475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.69 295.608) rotate(-90) scale(107.558 61.0898)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_239_475",
    x1: 199.239,
    y1: 246.786,
    x2: 233.063,
    y2: 203.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonDiamond);
export default __webpack_public_path__ + "static/media/hexagon_diamond.3a622d92d7435a797dac6a7d071b7aa1.svg";
export { ForwardRef as ReactComponent };